import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { first, map } from 'rxjs';
import { RouterSelectors } from '../../state/router.selectors';
import { SharedCvDataActions } from './state/shared-cv-data.actions';

export const SharedCvDataAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(RouterSelectors.selectParams).pipe(
    first(), // take the first emitted value and complete
    map((data) => {
      store.dispatch(
        new SharedCvDataActions.getCvData(route.params['companyId'], route.params['data']),
      );
      return true;
    }),
  );
};
